const initialState = {
  expand: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'expand':
      return { ...state, expand: true };
    case 'collapse':
      return { ...state, expand: false };
    default:
      return state;
  }
};
